export const searchConstants = {
  //login
  SEARCH_SKILL_USER_ACTION_REQUEST: "SEARCH_SKILL_USER_ACTION_REQUEST",
  SEARCH_SKILL_USER_ACTION_SUCCESS: "SEARCH_SKILL_USER_ACTION_SUCCESS",
  SEARCH_SKILL_USER_ACTION_FAILURE: "SEARCH_SKILL_USER_ACTION_FAILURE",

  SEARCH_JOB_USER_ACTION_REQUEST: "SEARCH_JOB_USER_ACTION_REQUEST",
  SEARCH_JOB_USER_ACTION_SUCCESS: "SEARCH_JOB_USER_ACTION_SUCCESS",
  SEARCH_JOB_USER_ACTION_FAILURE: "SEARCH_JOB_USER_ACTION_FAILURE",

  SEARCH_EVENT_USER_ACTION_REQUEST: "SEARCH_EVENT_USER_ACTION_REQUEST",
  SEARCH_EVENT_USER_ACTION_SUCCESS: "SEARCH_EVENT_USER_ACTION_SUCCESS",
  SEARCH_EVENT_USER_ACTION_FAILURE: "SEARCH_EVENT_USER_ACTION_FAILURE",

  SEARCH_COMPANY_USER_ACTION_REQUEST: "SEARCH_COMPANY_USER_ACTION_REQUEST",
  SEARCH_COMPANY_USER_ACTION_SUCCESS: "SEARCH_COMPANY_USER_ACTION_SUCCESS",
  SEARCH_COMPANY_USER_ACTION_FAILURE: "SEARCH_COMPANY_USER_ACTION_FAILURE",

  SEARCH_ASSESSMENT_KIT_USER_ACTION_REQUEST:
    "SEARCH_ASSESSMENT_KIT_USER_ACTION_REQUEST",
  SEARCH_ASSESSMENT_KIT_USER_ACTION_SUCCESS:
    "SEARCH_ASSESSMENT_KIT_USER_ACTION_SUCCESS",
  SEARCH_ASSESSMENT_KIT_USER_ACTION_FAILURE:
    "SEARCH_ASSESSMENT_KIT_USER_ACTION_FAILURE",

  SEARCH_COUNTRY_USER_ACTION_REQUEST: "SEARCH_COUNTRY_USER_ACTION_REQUEST",
  SEARCH_COUNTRY_USER_ACTION_SUCCESS: "SEARCH_COUNTRY_USER_ACTION_SUCCESS",
  SEARCH_COUNTRY_USER_ACTION_FAILURE: "SEARCH_COUNTRY_USER_ACTION_FAILURE",

  SEARCH_CITY_USER_ACTION_REQUEST: "SEARCH_CITY_USER_ACTION_REQUEST",
  SEARCH_CITY_USER_ACTION_SUCCESS: "SEARCH_CITY_USER_ACTION_SUCCESS",
  SEARCH_CITY_USER_ACTION_FAILURE: "SEARCH_CITY_USER_ACTION_FAILURE",

  SEARCH_STATE_USER_ACTION_REQUEST: "SEARCH_STATE_USER_ACTION_REQUEST",
  SEARCH_STATE_USER_ACTION_SUCCESS: "SEARCH_STATE_USER_ACTION_SUCCESS",
  SEARCH_STATE_USER_ACTION_FAILURE: "SEARCH_STATE_USER_ACTION_FAILURE",

  SEARCH_CANDIDATE_KANBAN_BOARD_USER_ACTION_REQUEST:
    "SEARCH_CANDIDATE_KANBAN_BOARD_USER_ACTION_REQUEST",
  SEARCH_CANDIDATE_KANBAN_BOARD_USER_ACTION_SUCCESS:
    "SEARCH_CANDIDATE_KANBAN_BOARD_USER_ACTION_SUCCESS",
  SEARCH_CANDIDATE_KANBAN_BOARD_USER_ACTION_FAILURE:
    "SEARCH_CANDIDATE_KANBAN_BOARD_USER_ACTION_FAILURE",

  SEARCH_COMPANY_ACTION_REQUEST: "SEARCH_COMPANY_ACTION_REQUEST",
  SEARCH_COMPANY_ACTION_SUCCESS: "SEARCH_COMPANY_ACTION_SUCCESS",
  SEARCH_COMPANY_ACTION_FAILURE: "SEARCH_COMPANY_ACTION_FAILURE",

  SEARCH_CANDIDATE_ACTION_REQUEST: "SEARCH_CANDIDATE_ACTION_REQUEST",
  SEARCH_CANDIDATE_ACTION_SUCCESS: "SEARCH_CANDIDATE_ACTION_SUCCESS",
  SEARCH_CANDIDATE_ACTION_FAILURE: "SEARCH_CANDIDATE_ACTION_FAILURE",

  SEARCH_JOBS_ACTION_REQUEST: "SEARCH_JOBS_ACTION_REQUEST",
  SEARCH_JOBS_ACTION_SUCCESS: "SEARCH_JOBS_ACTION_SUCCESS",
  SEARCH_JOBS_ACTION_FAILURE: "SEARCH_JOBS_ACTION_FAILURE",

  SEARCH_MENTOR_ACTION_REQUEST: "SEARCH_MENTOR_ACTION_REQUEST",
  SEARCH_MENTOR_ACTION_SUCCESS: "SEARCH_MENTOR_ACTION_SUCCESS",
  SEARCH_MENTOR_ACTION_FAILURE: "SEARCH_MENTOR_ACTION_FAILURE",

  GET_ALL_SKILLS_ACTION_REQUEST: "GET_ALL_SKILLS_ACTION_REQUEST",
  GET_ALL_SKILLS_ACTION_SUCCESS: "GET_ALL_SKILLS_ACTION_SUCCESS",
  GET_ALL_SKILLS_ACTION_FAILURE: "GET_ALL_SKILLS_ACTION_FAILURE",
};
